import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import slide1Img from "../assets/slider/slide1.png";
import slide2Img from "../assets/slider/slide2.png";
import slide3Img from "../assets/slider/slide3.png";

const SLIDES = [
  {
    image: slide1Img,
    subtitle: "Traditional & Hygiene",
    title: "For the love of delicious food",
    text: "Come with family & feel the joy of mouthwatering food",
    buttonText: "view our menu",
    buttonLink: "/menu",
  },
  {
    image: slide2Img,
    subtitle: "Barbequeen Restaurant",
    title: "Mood to have Grill chicken or Briyani?",
    text: "The perfect restaurant that your heart longs for and satisfy your tastebuds.",
    buttonText: "view our menu",
    buttonLink: "/menu",
  },
  {
    image: slide3Img,
    subtitle: "Mandi Varieties",
    title: "Taste the Excitement: Mandi Biryani Launching",
    text: "Share this with your family and friends",
    buttonText: "VIEW OUR MENU",
    buttonLink: "/menu",
  },
];

const HeroSection = () => {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  const startTimer = useCallback(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setCurrent((c) => (c === SLIDES.length - 1 ? 0 : c + 1));
    }, 5000);
  }, []);

  useEffect(() => {
    startTimer();
    return () => clearInterval(timerRef.current);
  }, [startTimer]);

  const prev = () => {
    setCurrent((c) => (c === 0 ? SLIDES.length - 1 : c - 1));
    startTimer();
  };

  const next = () => {
    setCurrent((c) => (c === SLIDES.length - 1 ? 0 : c + 1));
    startTimer();
  };

  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden bg-black text-white">
      {/* ── Main SEO H1 Heading ── */}
      <h1 className="sr-only">
        Barbequeen – Authentic Indian BBQ, Biryani & Grill Restaurant
      </h1>

      {/* ── Slideshow ── */}
      {SLIDES.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === current ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
        >
          {/* Background image */}
          <div
            className="absolute inset-0 bg-cover bg-center transition-transform duration-[8000ms] ease-out scale-105"
            style={{
              backgroundImage: `url(${slide.image})`,
              transform: index === current ? "scale(1)" : "scale(1.08)",
            }}
          />
          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-black/60" />

          {/* Content Box */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="max-w-[1280px] w-full mx-auto px-4 lg:px-8 text-center">
              <div className="max-w-3xl mx-auto space-y-6">

                {/* Subtitle */}
                {index === current && (
                  <div className="flex items-center justify-center gap-3 animate-fade-in-up">
                    <span className="w-8 h-[2px] bg-[#9b1c2e]" />
                    <span className="text-[11px] sm:text-[12px] font-bold tracking-[0.3em] uppercase text-[#c0424e]">
                      {slide.subtitle}
                    </span>
                  </div>
                )}

                {/* Main Heading */}
                {index === current && (
                  <h2 className="text-[32px] sm:text-[46px] lg:text-[56px] font-bold uppercase leading-[1.1] tracking-wide animate-fade-in-up [animation-delay:200ms]">
                    {slide.title}
                  </h2>
                )}

                {/* Description */}
                {index === current && (
                  <p className="font-sans text-sm sm:text-base text-gray-300 leading-relaxed max-w-lg animate-fade-in-up [animation-delay:400ms]">
                    {slide.text}
                  </p>
                )}

                {/* Buttons */}
                {index === current && (
                  <div className="flex flex-wrap items-center justify-center gap-4 pt-4 animate-fade-in-up [animation-delay:600ms]">
                    <Link
                      to={slide.buttonLink}
                      className="font-sans inline-flex items-center px-8 py-3.5 bg-[#9b1c2e] hover:bg-[#7d1624] text-white text-[12px] font-bold tracking-widest uppercase transition-all duration-200"
                    >
                      {slide.buttonText}
                    </Link>
                    <Link
                      to="/reservation"
                      className="font-sans inline-flex items-center px-8 py-3.5 border border-white/30 hover:border-white text-white text-[12px] font-bold tracking-widest uppercase transition-all duration-200"
                    >
                      book a table
                    </Link>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      ))}

      {/* ── Left Sidebar (Social Links) ── */}
      <div className="hidden md:flex absolute left-8 top-1/2 -translate-y-1/2 flex-col items-center gap-6 z-20">
        <span className="w-[1px] h-14 bg-white/20" />
        <ul className="flex flex-col gap-4 text-[11px] font-bold tracking-widest text-gray-400">
          <li>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors vertical-text">
              FB
            </a>
          </li>
          <li>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors vertical-text">
              IG
            </a>
          </li>
          <li>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors vertical-text">
              YT
            </a>
          </li>
        </ul>
        <span className="w-[1px] h-14 bg-white/20" />
      </div>

      {/* ── Right Sidebar (Call / Booking) ── */}
      <div className="hidden md:flex absolute right-8 top-1/2 -translate-y-1/2 flex-col items-center gap-6 z-20">
        <span className="w-[1px] h-14 bg-white/20" />
        <a href="tel:+919597228788" className="text-[11px] font-bold tracking-widest text-gray-400 hover:text-white transition-colors vertical-text whitespace-nowrap">
          BOOKING : +91 95972 28788
        </a>
        <span className="w-[1px] h-14 bg-white/20" />
      </div>

      {/* ── Navigation Arrows ── */}
      <button
        onClick={prev}
        className="absolute left-4 sm:left-8 bottom-28 sm:bottom-auto sm:top-1/2 sm:-translate-y-1/2 w-12 h-12 rounded-full border border-white/20 hover:border-white bg-black/35 flex items-center justify-center hover:bg-[#9b1c2e] hover:border-[#9b1c2e] text-white transition-all duration-300 z-20"
        aria-label="Previous slide"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button
        onClick={next}
        className="absolute right-4 sm:right-8 bottom-28 sm:bottom-auto sm:top-1/2 sm:-translate-y-1/2 w-12 h-12 rounded-full border border-white/20 hover:border-white bg-black/35 flex items-center justify-center hover:bg-[#9b1c2e] hover:border-[#9b1c2e] text-white transition-all duration-300 z-20"
        aria-label="Next slide"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* ── Circular Bottom Badge (Scroll / Explore) ── */}
      <a
        href="#about-us"
        className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-20 animate-bounce-slow"
      >
        <div className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:border-white transition-colors bg-black/20">
          <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 13l-7 7-7-7m14-6l-7 7-7-7" />
          </svg>
        </div>
      </a>


    </section>
  );
};

export default HeroSection;
